var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 68,
    viewBox: "0 0 63 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1963 14.2422L35.5792 18.1785L47.3283 30.9922H5.8474V36.5756H47.3283L35.5536 49.3893L39.1963 53.3256L57.1534 33.7839L39.1963 14.2422Z",
    fill: "#B2CE53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionRight);
export default __webpack_public_path__ + "static/media/Direction Right.407acc0f62239e6e79270fb107ca775c.svg";
export { ForwardRef as ReactComponent };